import {
  extend,
  bool as boolType,
  params,
  shape,
  string as stringType,
  arrayOf,
} from '@thd-nucleus/data-sources';
import { Buybox } from '@thd-olt-component-react/buybox';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { MediaGalleryDesktop } from '@thd-olt-component-react/media-gallery';
import { Price } from '@thd-olt-component-react/price';

const ProductPodAndMediaGallery = extend(
  {},
  ProductPod.dataModel.product,
  MediaGalleryDesktop.dataModel.product,
  {
    identifiers: shape({
      itemId: stringType(),
      isSuperSku: boolType(),
      parentId: stringType(),
      canonicalUrl: stringType(),
      brandName: stringType(),
      modelNumber: stringType(),
      productLabel: stringType(),
      productType: stringType(),
    }),
    details: shape({
      description: stringType(),
    }),
    info: shape({
      classNumber: stringType(),
      subClassNumber: stringType(),
      productDepartment: stringType(),
      quantityLimit: stringType(),
      hasServiceAddOns: stringType(),
    }),
    availabilityType: shape({
      discontinued: stringType(),
      status: stringType(),
      type: stringType(),
      buyable: stringType(),
    }),
    pricing: shape({
      ...Price.dataModel.product.pricing,
    })
  }
);

export const productConfiguratorDataModel = extend(
  {
    product: params({
      itemId: stringType().isRequired()
    }).shape({
      itemId: stringType(),
      dataSource: stringType(),
      identifiers: shape({
        productLabel: stringType(),
      }),
    }),
  },
  {
    clientOnlyProduct: params({
      itemId: stringType().isRequired()
    }).shape({
      itemId: stringType(),
      dataSources: stringType(),
      info: shape({
        gccExperienceOmsId: stringType(),
        recommendationFlags: shape({
          visualNavigation: boolType(),
          pipCollections: boolType(),
          packages: boolType(),
          ACC: boolType(),
          collections: boolType(),
          frequentlyBoughtTogether: boolType(),
          bundles: boolType(),
          batItems: boolType(),
        }),
        dotComColorEligible: boolType(),
        globalCustomConfigurator: shape({
          customPosition: stringType(),
        }),
      }),
      identifiers: shape({
        roomVOEnabled: boolType(),
        productType: stringType(),
        skuClassification: stringType(),
      }),
      availabilityType: shape({
        discontinued: boolType(),
        type: stringType(),
      }),
      fulfillment: params({ storeId: stringType() }).shape({
        backordered: boolType(),
        fulfillmentOptions: arrayOf(
          shape({
            type: stringType(),
            fulfillable: boolType(),
            services: arrayOf(
              shape({
                type: stringType(),
                locations: arrayOf(
                  shape({
                    isAnchor: boolType(),
                    inventory: shape({
                      isLimitedQuantity: boolType(),
                      isOutOfStock: boolType(),
                    }),
                  })
                ),
              })
            ),
          })
        ),
      }),
    }),
  },
  {
    clientOnlyProduct: params({ itemId: stringType().isRequired }).shape({
      seoDescription: stringType(),
    }),
  },
  {
    products: params({
      dataSource: stringType(),
      itemIds: arrayOf(stringType().isRequired()).isRequired()
    }).arrayOf(ProductPodAndMediaGallery),
  },
  Buybox
);
